export * from '@trilogy-ds/react/lib/components/pagination';
//# sourceMappingURL=index.js.map